import M_TOOLKIT from '../../../../main/components/toolkit/index.js'
import M_URL from '../../../../main/components/url/index.js'
import M_ENV from '../../../../main/components/env/index.js'
import M_COOKIE from '../../../../main/components/cookie/index.js'
import M_UA_PARSER from '../../../../main/components/ua_parser/index.js'

// 获取事件公参
const M_EVENT_PARAMS = (params) => {
    return {
        event_code: params.event_code || '', // 事件code
        flx_page: params.flx_page || '', // 页面Code
        flx_domain: params.flx_domain || '', // 上报来源
        flx_module: params.flx_module || '', // 模块ID
        flx_element: params.flx_element || '', // 元素Code
        fix_element_type: params.fix_element_type || '', // 元素类型
        fix_element_name: params.fix_element_name || '', // 元素文案
        param_content: params.param_content || '' // 参数值
    }
}

// 获取public参数
const M_PUBLIC_PARAMS = () => {

    let device_info = {
        app_id: 'com.lexin.web', // app中写死为com.lexin.web，由后台定义进行数据采集区分
        ua: M_ENV.userAgent,
        device_system: M_ENV.deviceSystem,
        device_system_version: M_ENV.deviceSystemVersion,
        device_model: M_ENV.deviceModel,
        device_brand: M_ENV.deviceBrand,
        screen_size: `${M_ENV.deviceWidth}*${M_ENV.deviceHeight}`
    }

    // app中相关参数又app自动获取，不给予封装
    if (!M_ENV.isInApp) {
        // H5 中通过 navigator.userAgent 取值
        let ua_parse = new M_UA_PARSER()
        let { os, device, ua } = ua_parse.getResult()

        Object.assign(device_info, {
            ua: ua,
            device_system: os.name,
            device_system_version: os.version,
            device_model: device.model,
            device_brand: device.vendor
        })
    }

    return M_TOOLKIT.filterNullData(device_info)
}

// 获取上报内容公共参数
const M_CONTENT_PARAMS = (instance) => {
    let page_info = getPageInfo()
    let user_info = getUserInfo()
    let sdk_info = getSdkInfo(instance)
    let content = {...page_info, ...user_info, ...sdk_info}
    return content
}

// 获取位置参数
const M_LOCATION_PARAMS = (instance) => {
    return new Promise((resolve) => {
        if (M_ENV.isWeexWeb && instance.locationInfoSwitch && navigator.geolocation && (typeof navigator.geolocation.getCurrentPosition === 'function')) {
            navigator.geolocation.getCurrentPosition((position) => {
                // 经纬度数据
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                })
            }, () => {
                resolve({})
            })
        } else {
            resolve({})
        }
    })
    
}

// 获取页面信息
const getPageInfo = () => {
    
    let page_name = ''
    let net_type = ''
    if (M_ENV.isWeexWeb && document) {
        page_name = document.title
        let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {}
        net_type = (connection.effectiveType || connection.type || 'UNKNOWN').toUpperCase()
    }
    const { crtUrl, refUrl } = M_URL.getUrl()
    const { dm } = M_URL.getUrlInfo(crtUrl || '')

    let page_info = {
        page_url: crtUrl || '',
        domain: dm || '',
        refer_url: refUrl || '',
        page_name: page_name,
        page_type: M_ENV.isWeexNativeInApp ? 'weex' : 'h5',
        net_type: net_type
    }

    return M_TOOLKIT.filterNullData(page_info)
}

// 获取用户信息
const getUserInfo = () => {
    let res = {}
    if (!M_ENV.isWeexNativeInApp) {
        res = {
            uid: M_COOKIE.get('uid') || '',
            channel_extend_info: JSON.parse(M_COOKIE.get('channel_extend_info') || '{}')
        }
    }
    return res
}

// 获取sdk版本信息
const getSdkInfo = (instance) => {
    return {
        js_sdk_version: instance.jsSdkVersion || ''
    }
}

export {
    M_EVENT_PARAMS,
    M_PUBLIC_PARAMS,
    M_CONTENT_PARAMS,
    M_LOCATION_PARAMS
}